export class IndicatorCalculation {
   id: number = 0;
   indicator: string = '';
   reductionType: string = '';
   metric: string = '';
   conversionFactor: number = 0;
}
    